


























































































import axios from 'axios';
import EventBus from '@/eventBus';
import Membership from './Membership.vue';
import { pick } from 'lodash';

import { errorResponse } from '@/types/GlobalTypes';

export default {
    i18n: {
        messages: {
            en: {
                messages: {
                    emailtaken: 'User with this email already exists. Please log in or reset your password.',
                },
            },
            de: {
                messages: {
                    emailtaken:
                        'Benutzer mit dieser E-Mail Adresse existiert bereits. Bitte logge dich ein oder setze dein Passwort zurück.',
                },
            },
        },
    },
    components: { Membership },
    name: 'Review',
    data() {
        return {
            AcceptPrivacyPolicy: false,
            AcceptTermsAndConditions: false,
            isReady: false,

            loading: false,
        };
    },
    computed: {
        // Read legal agreements from the store (loaded once on app start).
        privacyPolicy() {
            return this.$store.state.privacyPolicy;
        },
        termsAndConditions() {
            return this.$store.state.termsAndConditions;
        },
        address() {
            return this.$store.state.newMembership.Address;
        },
        account() {
            return this.$store.state.newMembership.Account;
        },

        plan() {
            return this.$store.state.newMembership.Plan;
        },
        extras() {
            return this.$store.state.newMembership.Extras;
        },
        membershipTotalPrice() {
            let total = this.calculatePrice(this.$store.state.newMembership.Plan);
            if (this.$store.state.newMembership && this.$store.state.newMembership.Extras) {
                this.$store.state.newMembership.Extras.forEach((element) => {
                    total += this.calculatePrice(element);
                });
            }

            return total.toFixed(2);
        },
        confirmationBtnTitle() {
            if (this.membershipTotalPrice > 0) {
                return this.$t('labels.ordercompletesubcription');
            }
            return this.$t('labels.ordercompletesubcriptionfree');
        },
    },
    mounted() {
        // next tick to make sure the data is loaded, then compute initial readiness
        this.$nextTick(() => {
            this.changeAcception();
        });
    },
    watch: {
        // Recompute readiness when legal agreements become available or change
        privacyPolicy() {
            this.changeAcception();
        },
        termsAndConditions() {
            this.changeAcception();
        },
    },
    methods: {
        formatDate(timestamp: string) {
            return new Date(timestamp).toLocaleDateString();
        },
        calculatePrice(item) {
            if (!item) return 0;
            if (item.TaxRate && item.TaxRate.Inclusive) {
                const price = item.PriceInCents / 100.0;
                return price;
            }
            const price = item.PriceInCents / 100.0;
            if (!item.TaxRate || (item.TaxRate && !item.TaxRate.Percentage)) {
                return price;
            }
            const totalPrice = price * (item.TaxRate.Percentage / 100 + 1);
            return totalPrice;
        },
        changeAcception() {
            let ready = true;
            if (this.privacyPolicy && !this.AcceptPrivacyPolicy) {
                ready = false;
            }

            if (this.termsAndConditions && !this.AcceptTermsAndConditions) {
                ready = false;
            }
            this.isReady = ready;
        },
        back() {
            if (this.$unleash.isEnabled('frontend.skip-payment')) {
                this.$store.commit('SET_STEP', 3);
            } else {
                this.$store.commit('PREVIOUS_STEP');
            }
        },

        prepareData() {
            const signUpRequest = {
                Coupon: this.$store.state.newMembership.Coupon,
                CustomerID: this.$store.state.newMembership.CustomerID,
                PaymentMethodeID: this.$store.state.newMembership.PaymentMethodeID,
                Account: {
                    Salutation: this.account.Salutation,
                    FirstName: this.account.FirstName,
                    LastName: this.account.LastName,
                    Email: this.account.Email,
                    Password: this.account.Password,
                    BirthDate: '',
                },
                Address: {
                    Company: this.address.Company,
                    Phone: this.account.Phone,
                    Address: this.address.Address,
                    AdditionalInfo: this.address.AdditionalInfo,
                    PostalCode: this.address.PostalCode,
                    City: this.address.City,
                    Country: this.address.Country,
                    VAT: this.address.VAT,
                },
                IsFromOA2Provider: this.$store.state.newMembership.IsFromOA2Provider,
                PlanID: '',
                PlanVersion: '',
                Extras: [],
                Agreements: [],
                InviteID: '',
            };

            if (this.$store.state.newMembership.InviteID && this.$store.state.newMembership.InviteID !== '') {
                signUpRequest.InviteID = this.$store.state.newMembership.InviteID;
            }

            if (this.account.BirthDate) {
                signUpRequest.Account.BirthDate = this.account.BirthDate;
            }

            if (this.plan) {
                signUpRequest.PlanID = this.plan.ID;
                signUpRequest.PlanVersion = this.plan.Version;
            }

            const extras = [];
            if (this.extras && this.extras.length !== 0) {
                this.extras.forEach((element, index) => {
                    extras.push({
                        ID: element.ID,
                        Version: element.Version,
                    });
                });
            }
            signUpRequest.Extras = extras;

            const Agreements = [];
            if (this.privacyPolicy && this.privacyPolicy.CreatedAt !== 0) {
                Agreements.push({
                    Version: this.privacyPolicy.CreatedAt,
                    Type: 0,
                });
            }

            if (this.termsAndConditions) {
                Agreements.push({
                    Version: this.termsAndConditions.CreatedAt,
                    Type: 1,
                });
            }

            signUpRequest.Agreements = Agreements;
            return signUpRequest;
        },

        create() {
            this.loading = true;
            const data = this.prepareData();
            const url = '/user/signupV3';

            axios({
                method: 'POST',
                url,
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(async (response) => {
                    this.$store.commit('RESET_MEMBERSHIP_PROVIDER');
                    this.$store.commit('RESET_NEW_MEMBERSHIP');
                    this.$router.push('/signup-success');
                })
                .catch(async (error) => {
                    // handle error
                    const errorMsg = error?.response?.data || ({} as errorResponse);
                    // log handled error to bugnsag
                    console.error(errorMsg);
                    // if error "code" = "ErrSubscriptionToPlanFailed",
                    // user was created but subscription failed
                    // log user in and redirect to account page
                    if (errorMsg.code === 'ErrSubscriptionToPlanFailed') {
                        // login successful, reset store and redirect to success page with error code
                        this.$store.commit('RESET_MEMBERSHIP_PROVIDER');
                        this.$store.commit('RESET_NEW_MEMBERSHIP');
                        this.$router.push({
                            path: '/signup-success',
                            query: {
                                errorcode: errorMsg.code,
                            },
                        });
                    }
                    let errorText = errorMsg.message || this.$t('errors.failedGeneric');
                    if (error?.response?.status === 409) {
                        errorText = this.$t('messages.emailtaken');
                    }
                    EventBus.$emit('ERROR', {
                        Message: errorText,
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
